<template>
    <div v-if="info" class="user-height">
        <div v-if="!inputBool">
            <div class="header flex flex-y">
                <div class="flex-1">
                </div>
                <div class="header-right buld" @click="shareData" v-if="info.is_doctor!==0">远程评估</div>
            </div>
            <div class="user-top flex">
                <router-link :to="{name:'profile'}" class="user-png">
                    <img :src="info.avatarUrl" v-if="info.avatarUrl"/>
                    <img src='../../../images/user.png' v-else />
                </router-link>
                <div class="flex-1 flex flex-y">
                    <div class="flex-1">
                        <div class="user-name">{{info.nikeName}}</div>
                        <div class="flex" v-if="info.is_doctor!==0">
                            <div class="user-hospital flex-1">{{info.company_name}}</div>
                            <div class="user-recharge">{{info.end_time? dateTime(info.end_time) : ""}}到期</div>
                        </div>
                        <div class="user-hospital" v-else>您还不是医生</div>
                    </div>
                </div>
            </div>
            <div class="user-search" v-if="info.doctor">
                <div class="flex">
                    <div class="user-input flex-1" @click="inputChange">
                        <van-icon name="search" />
                        <div class="search">请搜索昵称、手机号码或身份证号</div>
                    </div>
                    <div class="user-add" @click="addFun">添加用户</div>
                </div>
            </div>

            <ul  class="user-ul">
                <li class="flex flex-y" v-for="(item,index) in companyList" v-bind:key="index">
                    <div class="li-png">
                        <img :src="item.avatarUrl" v-if="item.avatarUrl"/>
                        <img src='../../../images/user.png' v-else />
                    </div>
                    <div class="flex-1 li-name">{{item.nikeName?item.nikeName:item.name}}</div>
                    <router-link :to="`/list/${item.id}`" class="li-report">报告列表</router-link>
                    <router-link :to="`/confirmAssess/5?user_id=${item.id}&return=1`" class="li-test">开始检测</router-link>
                </li>
            </ul>
            <div v-if="companyList.length<total && info.is_doctor!==0" class="flex flex-x flex-y user-loading"><van-loading /></div>
            <div class="alert" v-if="addBool">
                <div class="alert-bottom">
                    <div class="alert-add">
                        <div class="add" @click="()=>linkFun('addUser',{},{
                            id:info.id
                        })">手动添加</div>
                        <div class="add" @click="()=>linkFun('addUserCode',{
                            user_id:info.id,
                            company_id:info.current_company_id
                        })">扫码添加</div>
                    </div>
                    <div class="alert-cancel" @click="addFun">取消</div>
                </div>
            </div>
            <div class="alert" v-if="shareBool" @click="()=>change({
                    key:'shareBool',
                    value:false
                })">
                <div class="alert-top">
                    <img src="../../../images/share.png" class="alert-share" />
                </div>
            </div>
        </div>
        <div v-else>
            <div class="header flex flex-y">
                <div class="header-left" @click="inputChange">
                    <van-icon name="arrow-left" />
                </div>
                <div class="header-center flex-1"></div>
                <div class="header-left"></div>
            </div>
            <form class="flex user-search-ui" v-on:submit.prevent="searchFun">
                <div class="user-input flex-1">
                    <van-icon name="search" />
                    <input class="search search-input" placeholder="请搜索昵称、手机号码或身份证号" v-model="search"/>
                </div>
                <div class="user-add add-width" @click="inputChange">取消</div>
            </form>
            <ul  class="user-ul" v-if="keywordsList.length>0">
                <li class="flex flex-y" v-for="(item,index) in keywordsList" v-bind:key="index">
                    <div class="li-png">
                        <img :src="item.avatarUrl" v-if="item.avatarUrl"/>
                        <img src='../../../images/user.png' v-else />
                    </div>
                    <div class="flex-1 li-name flex flex-y">
                        <div>
                            <div>{{item.nikeName}}</div>
                            <div class="li-user">{{item.phone}}</div>
                            <div class="li-user">{{item.id_entity_card}}</div>
                        </div>
                    </div>
                    <router-link :to="`/list/${item.id}`"  class="li-report">报告列表</router-link>
                    <router-link :to="`/confirmAssess/5?user_id=${item.id}&return=1`" class="li-test">开始检测</router-link>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { mapActions , mapState , mapMutations } from 'vuex';
let timer;
export default {
  name: 'user',
  created:function(){
    this.axiosMain(this);
    this.configData();
    window.addEventListener('scroll', this.onSrollFun)
  },
  computed:{
        search:{
            get() { return this.$store.state.user.keywords },
            set(val){this.change({
                key:'keywords',
                value:val
            });}
        },
      ...mapState('user',['info','hospital','switchBool','addBool','companyList','inputBool','keywordsList','shareBool','total','rechargeBool','money','playBool']),
  },
  methods:{
      linkFun(value,query,params){
          this.$router.push(
              {
                  name:value,
                  query: query,
                  params:params
              }
          );
          this.addFun();
      },
      dateTime(date){
          return date.split(' ')[0];
      },
      onSrollFun(){
            let _this = this;
            clearTimeout(timer);
            timer = setTimeout(()=>{
                let height = document.documentElement.scrollHeight-document.documentElement.scrollTop-document.documentElement.clientHeight;
                //获取滚动条到底部的距离
                if(height<1000){
                    _this.companyData();
                }
            },1000)
      },
      searchFun(){
          this.companyData({
              key:'keywordsList',
              page:1
          })
      },
      ...mapMutations('user',['addFun','inputChange','change']),
      ...mapActions('user',['axiosMain','switchData','shareData','companyData','configData'])
  },
  destroyed(){
      window.removeEventListener('scroll', this.onSrollFun, false);
  }
}
</script>
<style lang="scss" scoped rel="stylesheet/scss">
  @import 'user';
</style>
